import Swal from "sweetalert2";
import { inter, white, primaryPink, primaryBlack, lemonMilk, Button } from "../Theme";
import withReactContent from "sweetalert2-react-content";
import styled from "styled-components";
import {ReactComponent as closeIcon} from "../resources/images/close.svg";

export const BasicPopup = withReactContent(Swal)

function showBasicPopup(title, text, buttonText) {
    BasicPopup.fire({
        html: (
            <CenteredPopupContent>
                <CloseButtonWrapper>
                    <CloseButton onClick={BasicPopup.clickConfirm} aria-label="Annuleren">
                        <CloseIcon />
                    </CloseButton>
                </CloseButtonWrapper>
                <PopupTitle>{title}</PopupTitle>
                <PopupText>{text}</PopupText>
                <ConfirmButton onClick={BasicPopup.clickConfirm}>{buttonText}</ConfirmButton>
            </CenteredPopupContent>
        ),
        customClass: {
            popup: "swal2-popup-custom",
        },
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: false,
    })
}

function showConfirmationPopup(title, text, positiveButtonText, positiveButtonCallback, negativeButtonText, negativeButtonCallback) {
    BasicPopup.fire({
        html: (
            <CenteredPopupContent>
                <ConfirmCloseButtonWrapper>
                    <CloseButton onClick={BasicPopup.clickCancel} aria-label="Annuleren">
                        <CloseIcon />
                    </CloseButton>
                </ConfirmCloseButtonWrapper>
                <PopupTitle>{title}</PopupTitle>
                <ConfirmPopupText>{text}</ConfirmPopupText>
                <ConfirmButton onClick={BasicPopup.clickConfirm}>{positiveButtonText}</ConfirmButton>
                {negativeButtonText && <CancelButton onClick={BasicPopup.clickCancel}>{negativeButtonText}</CancelButton>}
            </CenteredPopupContent>
        ),
        customClass: {
            popup: "swal2-popup-custom-confirm",
            htmlContainer: "swal2-popup-custom-confirm-container"
        },
        heightAuto: false,
        showCancelButton: false,
        showConfirmButton: false,
        padding: 0,

    }).then((result) => {
        if (result.isConfirmed) {
            positiveButtonCallback()
        } else {
            if(negativeButtonCallback) negativeButtonCallback()
        }
    })
}

export const CenteredPopupContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding-bottom: 8px;
`

export const CloseButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    align-items: center; 
    gap: 16px;   
`

const ConfirmCloseButtonWrapper = styled(CloseButtonWrapper)`
    padding: 10px 10px 0 0;
`;

export const CloseButton = styled(Button)`
    background: transparent;
    width: 32px;
`

export const CloseIcon = styled(closeIcon)`
    margin: auto;
    color: ${primaryBlack};
`

export const PopupTitle = styled.div`
    font-family: ${inter};
    font-size: 18px;
    font-weight: 600;
    color: ${primaryBlack};
    margin-top: 12px;
`

export const PopupText = styled.div`
    font-family: ${inter};
    color: ${primaryBlack};
    font-size: 16px;
    font-weight: 400;
    margin-top: 12px;
`

const ConfirmPopupText = styled(PopupText)`
    padding: 0 20px;
`

export const ConfirmButton = styled(Button)`
    background: ${primaryPink};
    font-family: ${lemonMilk};
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    color: ${white};
    min-width: 160px;
    min-height: 38px;
    border: none;
    margin-top: 20px;
    padding: 14px 20px;
`

export const CancelButton = styled(Button)`
    background: none;
    font-family: ${inter};
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    color: ${primaryBlack};
    min-width: 160px;
    min-height: 38px;
    border: none;
    padding: 14px 20px;
    margin: 4px 0 6px 0;
`

export default showBasicPopup;
export { showConfirmationPopup }